"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyTotp = exports.verifySecurityQuestion = exports.verifyRequest = exports.verifyAlias = exports.updatePassword = exports.unlinkProvenanceOauthProvider = exports.tokenRequest = exports.tokenRedeem = exports.toggleTwoFactor = exports.timeout = exports.rotateJwt = exports.revokeVerifiedAlias = exports.reload = exports.registerLOUser = exports.register = exports.redeemTotp = exports.magiclinkReset = exports.magiclinkRedeem = exports.magiclinkLogin = exports.magiclinkAutoLogin = exports.logout = exports.logisterAndSaveHeloc = exports.login = exports.linkProvenanceOauthProvider = exports.getTotpUrl = exports.getSecurityQuestions = exports.getIdentity = exports.coDeedLogin = exports.addAlias = exports.VERIFY_TOTP = exports.VERIFY_SECURITY_QUESTION = exports.VERIFY_REQUEST = exports.VERIFY_ALIAS = exports.UPDATE_PASSWORD = exports.UNLINK_PROVENANCE_OAUTH_PROVIDER = exports.TOKEN_REQUEST_2FA = exports.TOKEN_REDEEM_2FA = exports.TOGGLE_2FA = exports.TIMEOUT = exports.ROTATE_JWT = exports.REVOKE_ALIAS = exports.RELOAD = exports.REGISTER = exports.REDEEM_TOTP = exports.MAGICLINK_RESET = exports.MAGICLINK_REDEEM = exports.MAGICLINK_LOGIN = exports.MAGICLINK_AUTO_LOGIN = exports.LO_REGISTRATION = exports.LOGOUT = exports.LOGIN = exports.LINK_PROVENANCE_OAUTH_PROVIDER = exports.GET_TOTP_URL = exports.GET_SECURITY_QUESTIONS = exports.GET_IDENTITY = exports.CO_DEED_LOGIN = exports.ADD_ALIAS = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var _helocActions = require("./heloc-actions");

var GET_IDENTITY = 'GET_IDENTITY';
exports.GET_IDENTITY = GET_IDENTITY;
var LOGIN = 'LOGIN';
exports.LOGIN = LOGIN;
var CO_DEED_LOGIN = 'CO_DEED_LOGIN';
exports.CO_DEED_LOGIN = CO_DEED_LOGIN;
var MAGICLINK_LOGIN = 'MAGICLINK_LOGIN';
exports.MAGICLINK_LOGIN = MAGICLINK_LOGIN;
var MAGICLINK_AUTO_LOGIN = 'MAGICLINK_AUTO_LOGIN';
exports.MAGICLINK_AUTO_LOGIN = MAGICLINK_AUTO_LOGIN;
var MAGICLINK_REDEEM = 'MAGICLINK_REDEEM';
exports.MAGICLINK_REDEEM = MAGICLINK_REDEEM;
var TOGGLE_2FA = 'TOGGLE_2FA';
exports.TOGGLE_2FA = TOGGLE_2FA;
var UPDATE_PASSWORD = 'UPDATE_PASSWORD';
exports.UPDATE_PASSWORD = UPDATE_PASSWORD;
var REGISTER = 'REGISTER';
exports.REGISTER = REGISTER;
var TOKEN_REQUEST_2FA = 'TOKEN_REQUEST_2FA';
exports.TOKEN_REQUEST_2FA = TOKEN_REQUEST_2FA;
var TOKEN_REDEEM_2FA = 'TOKEN_REDEEM_2FA';
exports.TOKEN_REDEEM_2FA = TOKEN_REDEEM_2FA;
var VERIFY_REQUEST = 'VERIFY_REQUEST';
exports.VERIFY_REQUEST = VERIFY_REQUEST;
var VERIFY_ALIAS = 'VERIFY_ALIAS';
exports.VERIFY_ALIAS = VERIFY_ALIAS;
var ADD_ALIAS = 'ADD_ALIAS';
exports.ADD_ALIAS = ADD_ALIAS;
var REVOKE_ALIAS = 'REVOKE_ALIAS';
exports.REVOKE_ALIAS = REVOKE_ALIAS;
var LINK_PROVENANCE_OAUTH_PROVIDER = 'LINK_PROVENANCE_OAUTH_PROVIDER';
exports.LINK_PROVENANCE_OAUTH_PROVIDER = LINK_PROVENANCE_OAUTH_PROVIDER;
var UNLINK_PROVENANCE_OAUTH_PROVIDER = 'UNLINK_PROVENANCE_OAUTH_PROVIDER';
exports.UNLINK_PROVENANCE_OAUTH_PROVIDER = UNLINK_PROVENANCE_OAUTH_PROVIDER;
var GET_TOTP_URL = 'GET_TOTP_URL';
exports.GET_TOTP_URL = GET_TOTP_URL;
var REDEEM_TOTP = 'REDEEM_TOTP';
exports.REDEEM_TOTP = REDEEM_TOTP;
var VERIFY_TOTP = 'VERIFY_TOTP';
exports.VERIFY_TOTP = VERIFY_TOTP;
var LO_REGISTRATION = 'LO_REGISTRATION';
exports.LO_REGISTRATION = LO_REGISTRATION;
var GET_SECURITY_QUESTIONS = 'GET_SECURITY_QUESTIONS';
exports.GET_SECURITY_QUESTIONS = GET_SECURITY_QUESTIONS;
var VERIFY_SECURITY_QUESTION = 'VERIFY_SECURITY_QUESTION';
exports.VERIFY_SECURITY_QUESTION = VERIFY_SECURITY_QUESTION;
var LOGOUT = 'LOGOUT';
exports.LOGOUT = LOGOUT;
var TIMEOUT = 'TIMEOUT';
exports.TIMEOUT = TIMEOUT;
var RELOAD = 'RELOAD';
exports.RELOAD = RELOAD;
var ROTATE_JWT = 'ROTATE_JWT';
exports.ROTATE_JWT = ROTATE_JWT;
var MAGICLINK_RESET = 'MAGICLINK_RESET';
exports.MAGICLINK_RESET = MAGICLINK_RESET;
var CONTEXT = '/identity/api/v1';
var SECURED_CONTEXT = '/identity/secure/api/v1';
var CONTEXT_V2 = '/identity/api/v2';
var CONTEXT_SA = '/service-application/api/v1/heloc';

var getIdentity = function getIdentity() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_IDENTITY, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/identity")));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}; // { email, password }


exports.getIdentity = getIdentity;

var login = function login(data) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPost)(LOGIN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/login"), data));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}; // { dob, last4Ssn, lastName, accessCode }


exports.login = login;

var coDeedLogin = function coDeedLogin(data) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxPost)(CO_DEED_LOGIN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/login/codeeder"), data));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}; // { email }


exports.coDeedLogin = coDeedLogin;

var magiclinkLogin = function magiclinkLogin(data) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxPost)(MAGICLINK_LOGIN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/magiclink/login"), data));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
}; // { email, redirectParam, passwordReset, params [ie. ?redirectWithAuth=true] }


exports.magiclinkLogin = magiclinkLogin;

var magiclinkAutoLogin = function magiclinkAutoLogin(data) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxPost)(MAGICLINK_AUTO_LOGIN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT_V2, "/magiclink/login").concat(data.params ? data.params : ''), data));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
}; // { encryptedToken }


exports.magiclinkAutoLogin = magiclinkAutoLogin;

var magiclinkRedeem = function magiclinkRedeem(data) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxPost)(MAGICLINK_REDEEM, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/magiclink/redeem"), data));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
}; // enabled={enabled}


exports.magiclinkRedeem = magiclinkRedeem;

var toggleTwoFactor = function toggleTwoFactor(enabled) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxPut)(TOGGLE_2FA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/2fa?enabled=").concat(enabled)));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
}; // { newPassword }


exports.toggleTwoFactor = toggleTwoFactor;

var updatePassword = function updatePassword(data) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxPut)(UPDATE_PASSWORD, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/pw"), data));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
/**
 * @param data
 * @param data.email {string}
 * @param data.phoneNumber {string}
 * @param data.password {string}
 * @param {string} [type] 'person' | 'entity' - ONLY VALID FOR FIGURE
 */


exports.updatePassword = updatePassword;

var register = function register(data, type) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (0, _ajax.ajaxPost)(REGISTER, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/registration/register").concat(type ? "/".concat(type) : ''), data));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
}; /// register: organization, password, firstName, lastName
/// used by Lead Referral Portal
/// Authentication is done here, and a jwt is returned (kind of weird that it's done in service-application)


exports.register = register;

var registerLOUser = function registerLOUser(data) {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(dispatch) {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (0, _ajax.ajaxPost)(LO_REGISTRATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT_SA, "/los/registration/identity"), data));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
}; // { loginUuid, alias: { value, type } }


exports.registerLOUser = registerLOUser;

var tokenRequest = function tokenRequest(data) {
  return /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(dispatch) {
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", (0, _ajax.ajaxPost)(TOKEN_REQUEST_2FA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/2fa/send"), data));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }();
}; // { loginUuid, token }


exports.tokenRequest = tokenRequest;

var tokenRedeem = function tokenRedeem(data) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(dispatch) {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", (0, _ajax.ajaxPut)(TOKEN_REDEEM_2FA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/2fa/redeem"), data));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x12) {
      return _ref12.apply(this, arguments);
    };
  }();
};

exports.tokenRedeem = tokenRedeem;

var getTotpUrl = function getTotpUrl() {
  return /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(dispatch) {
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", (0, _ajax.ajaxGet)(GET_TOTP_URL, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/totp")));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x13) {
      return _ref13.apply(this, arguments);
    };
  }();
}; // { loginUuid, code }


exports.getTotpUrl = getTotpUrl;

var redeemTotp = function redeemTotp(data) {
  return /*#__PURE__*/function () {
    var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(dispatch) {
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", (0, _ajax.ajaxPost)(REDEEM_TOTP, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/totp"), data));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function (_x14) {
      return _ref14.apply(this, arguments);
    };
  }();
}; // { code }


exports.redeemTotp = redeemTotp;

var verifyTotp = function verifyTotp(data) {
  return /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(dispatch) {
      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", (0, _ajax.ajaxPost)(VERIFY_TOTP, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/totp/verify"), data));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function (_x15) {
      return _ref15.apply(this, arguments);
    };
  }();
}; // { verificationType, alias }


exports.verifyTotp = verifyTotp;

var verifyRequest = function verifyRequest(data) {
  return /*#__PURE__*/function () {
    var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(dispatch) {
      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", (0, _ajax.ajaxPost)(VERIFY_REQUEST, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/verification/send"), data));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function (_x16) {
      return _ref16.apply(this, arguments);
    };
  }();
}; // { token, alias }


exports.verifyRequest = verifyRequest;

var verifyAlias = function verifyAlias(data) {
  return /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(dispatch) {
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", (0, _ajax.ajaxPut)(VERIFY_ALIAS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/verification/verify"), data));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function (_x17) {
      return _ref17.apply(this, arguments);
    };
  }();
};

exports.verifyAlias = verifyAlias;

var revokeVerifiedAlias = function revokeVerifiedAlias(aliasUuid) {
  return /*#__PURE__*/function () {
    var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(dispatch) {
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", (0, _ajax.ajaxPut)(REVOKE_ALIAS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/verification/revoke"), {
                aliasUuid: aliasUuid
              }));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    return function (_x18) {
      return _ref18.apply(this, arguments);
    };
  }();
};

exports.revokeVerifiedAlias = revokeVerifiedAlias;

var addAlias = function addAlias(data) {
  return /*#__PURE__*/function () {
    var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(dispatch) {
      return _regenerator.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", (0, _ajax.ajaxPut)(ADD_ALIAS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/identity/alias"), data));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    return function (_x19) {
      return _ref19.apply(this, arguments);
    };
  }();
};

exports.addAlias = addAlias;

var linkProvenanceOauthProvider = function linkProvenanceOauthProvider(redirectUrl) {
  return /*#__PURE__*/function () {
    var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(dispatch) {
      return _regenerator.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", (0, _ajax.ajaxGet)(LINK_PROVENANCE_OAUTH_PROVIDER, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/oauth/provenance?redirectUrl=").concat(redirectUrl)));

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    return function (_x20) {
      return _ref20.apply(this, arguments);
    };
  }();
};

exports.linkProvenanceOauthProvider = linkProvenanceOauthProvider;

var unlinkProvenanceOauthProvider = function unlinkProvenanceOauthProvider() {
  return /*#__PURE__*/function () {
    var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(dispatch) {
      return _regenerator.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", (0, _ajax.ajaxPost)(UNLINK_PROVENANCE_OAUTH_PROVIDER, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURED_CONTEXT, "/oauth/provenance/unlink")));

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    return function (_x21) {
      return _ref21.apply(this, arguments);
    };
  }();
};

exports.unlinkProvenanceOauthProvider = unlinkProvenanceOauthProvider;

var getSecurityQuestions = function getSecurityQuestions(data) {
  return /*#__PURE__*/function () {
    var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(dispatch) {
      return _regenerator.default.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", (0, _ajax.ajaxPost)(GET_SECURITY_QUESTIONS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/question/retrieve"), data));

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    return function (_x22) {
      return _ref22.apply(this, arguments);
    };
  }();
};

exports.getSecurityQuestions = getSecurityQuestions;

var verifySecurityQuestion = function verifySecurityQuestion(data) {
  return /*#__PURE__*/function () {
    var _ref23 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(dispatch) {
      return _regenerator.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", (0, _ajax.ajaxPost)(VERIFY_SECURITY_QUESTION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/question"), data));

            case 1:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    return function (_x23) {
      return _ref23.apply(this, arguments);
    };
  }();
};

exports.verifySecurityQuestion = verifySecurityQuestion;
var timeout = (0, _reduxActions.createAction)(TIMEOUT);
exports.timeout = timeout;
var reload = (0, _reduxActions.createAction)(RELOAD);
exports.reload = reload;
var rotateJwt = (0, _reduxActions.createAction)(ROTATE_JWT);
exports.rotateJwt = rotateJwt;
var logout = (0, _reduxActions.createAction)(LOGOUT);
exports.logout = logout;
var magiclinkReset = (0, _reduxActions.createAction)(MAGICLINK_RESET);
/**
 * @deprecated consent types retrieved after register
 */

exports.magiclinkReset = magiclinkReset;

var logisterAndSaveHeloc = function logisterAndSaveHeloc(data) {
  return function (dispatch) {
    return dispatch(register({
      email: data.email,
      phoneNumber: data.phoneNumber
    })).then(function () {
      return dispatch((0, _helocActions.saveHeloc)());
    });
  };
};

exports.logisterAndSaveHeloc = logisterAndSaveHeloc;